/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Shy_Soft_Otter_AskInputs */

const en_shy_soft_otter_ask = /** @type {(inputs: Shy_Soft_Otter_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} removed by this report's block list`)
};

const de_shy_soft_otter_ask = /** @type {(inputs: Shy_Soft_Otter_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} durch Sperrliste dieses Reports entfernt`)
};

/**
* | output |
* | --- |
* | "{count} removed by this report's block list" |
*
* @param {Shy_Soft_Otter_AskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_soft_otter_ask = /** @type {((inputs: Shy_Soft_Otter_AskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Soft_Otter_AskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_soft_otter_ask(inputs)
	return de_shy_soft_otter_ask(inputs)
});